import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'app/services/client-service';
import { ClientDataDTO } from 'app/header-footer-template/model/ClientDataDTO';
import { CommonsText } from 'app/commons/CommonsText';

type PreferenceField = 'insuranceAdvertising' | 'legalServicesAdvertising';

@Component({
    selector: 'app-profile-consent',
    templateUrl: './profile-consent.component.html',
    styleUrls: ['./profile-consent.component.scss']
})
export class ProfileConsentComponent implements OnInit {

    // UI semantic: switch ON = "no acepto publicidad de seguros" (matches Figma copy).
    // Server semantic is inverted by client-service.onModifyPreferences:
    //   clientData.insuranceAdvertising true  ⇄  UI switch OFF
    //   clientData.insuranceAdvertising false ⇄  UI switch ON
    insuranceAdvertising = false;
    legalServicesAdvertising = true;

    running: { [k in PreferenceField]: boolean } = {
        insuranceAdvertising: false,
        legalServicesAdvertising: false
    };

    constructor(private clientService: ClientService,
                private toastr: ToastrService) {}

    ngOnInit(): void {
        const data = this.clientService.clientData;
        if (data) {
            this.insuranceAdvertising = !data.insuranceAdvertising;
            this.legalServicesAdvertising = !!data.legalServicesAdvertising;
        }
    }

    toggle(field: PreferenceField): void {
        if (this.running[field]) { return; }
        const previous = this[field];
        this[field] = !this[field];
        this.persist(field, previous);
    }

    private persist(field: PreferenceField, previous: boolean): void {
        this.running[field] = true;

        const data = this.clientService.clientData;
        const param = Object.assign(new ClientDataDTO(), data, {
            insuranceAdvertising: this.insuranceAdvertising,
            legalServicesAdvertising: this.legalServicesAdvertising
        });

        this.clientService.onModifyPreferences(param)
            .then(() => {
                this.running[field] = false;
                this.toastr.success('Preferencias actualizadas',
                    CommonsText.OPERACION_COMPLETADA, { timeOut: 4000 });
            })
            .catch(error => {
                this.running[field] = false;
                this[field] = previous;
                const resp = error && error.error && error.error.response;
                const msg = resp ? resp.toString() : CommonsText.PROBLEMA_DE_CONECTIVIDAD;
                this.toastr.error(msg, CommonsText.ERROR_DE_OPERACION, { timeOut: 5000 });
            });
    }
}
